export default __webpack_public_path__ + "static/media/ico-material-ac.e4bb0974.svg";